import Vue from 'vue';
// initial state
const state = {
  selectedContact: null,
  contacts: [],
  metadata: {},
  roles: {},
  status: null,
  distinctValues: {},
  types: [],
  searchTypes: [],
  customFieldGroups: [],
  typeCategories: [],
};

function findAndReplaceContact(currentState, newContact) {
  currentState.contacts = state.contacts.filter(obj => obj.id !== newContact.id);
  currentState.contacts.push(newContact);
}

const mutations = {
  setTypes(currentState, types) {
    currentState.types = types;
  },
  setTypeCategories(currentState, categories) {
    currentState.typeCategories = categories;
  },
  setSearchTypes(currentState, searchTypes) {
    currentState.searchTypes = searchTypes;
  },
  setSelectedContact(currentState, contact) {
    currentState.selectedContact = contact;
  },
  setRole(currentState, { contactId, roles }) {
    Vue.set(currentState.roles, [contactId], roles);
  },
  setContacts(currentState, contacts = []) {
    currentState.contacts = contacts;
  },
  setStatus(currentState, data) {
    currentState.status = data;
  },
  setContact(currentState, contact = null) {
    findAndReplaceContact(currentState, contact);
  },
  editContact(currentState, { field, value }) {
    if (currentState.selectedContact === null) {
      currentState.selectedContact = {};
    }
    currentState.selectedContact[field] = value;
  },
  deleteContact(currentState, { contactId }) {
    currentState.contacts = currentState.contacts.filter(obj => obj.id !== contactId.id);
  },
  setContactsMetadata(currentState, params) {
    const { size, start, count } = params;
    const newMeta = {};
    newMeta[params.key] = { size, start, count };
    currentState.metadata = Object.assign(newMeta);
  },
  setDistinctValues(currentState, { column, values }) {
    currentState.distinctValues[column] = values;
  },
};

export { mutations, state };
